import { z } from 'zod';
export const inventoryAdjustSchema = z.object({
    account_id: z.number().int().positive('Account is required'),
    product_id: z.number().int().positive('Product is required'),
    quantity_change: z.number().refine((v) => v !== 0, 'Adjustment cannot be zero'),
    reason: z.string().min(1, 'Reason is required for audit trail'),
});
//# sourceMappingURL=inventory.js.map